import { types, actions } from './requests'
export const GETMACHINETYPELIST_TYPES = {
    ...types('GETMACHINETYPELIST'),
}
export const GETMACHINETYPELIST_ACTIONS = {
    ...actions('GETMACHINETYPELIST'),
}
